<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">二次订单详情</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!--pages/secondPaymentDetail/secondPaymentDetail.wxml-->
    <!--pages/pickupOrder/pickupOrder.wxml-->
    <!-- <div class="secondPaymentDetail_title">二次缴费项目详情</div> -->
    <div class="secondPaymentDetail_box">
      <div class="secondPaymen-confirmtoptext">
        <div class="secondPaymen-confirm-pro">项目</div>
        <div class="secondPaymen-confirm-mprice">成本价</div>
        <div class="secondPaymen-confirm-price">售价</div>
      </div>
      <div class="secondPaymen-confirmbox1" v-for="(item,index) in orderDetail.projects">
        <div class="secondPaymen-confirm-proname">{{item.project}}</div>
        <div class="secondPaymen-confirm-mprice1">￥{{item.m_price}}</div>
        <div class="secondPaymen-confirm-price1">￥{{item.price}}</div>
      </div>
      <textarea v-if="orderDetail.remark" class="secondPaymen-confirm-text" disabled="true">{{orderDetail.remark}}</textarea>
    </div>
    <div class="secondPaymentDetail_pickaddressbox">
      <div class="secondPaymentDetail_addresstitle">维修厂</div>
      <div class="secondPaymentDetail_addressdetail">{{orderDetail.wxc_name}}</div>
    </div>
    <div class="secondPaymentDetail_pickaddressbox">
      <div class="secondPaymentDetail_addresstitle">缴费状态</div>
      <div class="secondPaymentDetail_addressdetail">{{orderDetail.status_str}}</div>
    </div>
    <div class="secondPaymentDetail_pickaddressbox">
      <div class="secondPaymentDetail_addresstitle1">合计</div>
      <div class="secondPaymentDetail_addressdetail">￥{{orderDetail.settlement_amount}}</div>
    </div>
    <!-- 支付 开始 -->
    <div v-if="orderDetail.pay_status==0" class="secondPayment_zhifu" @click="payment()">确认支付</div>
    <div v-else class="secondPayment_zhifu" @click="toIndex()">返回首页</div>
    <!-- 支付 结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        orderDetail: {},
        orderNo: "",
        userId: ""

      }
    },
    created() {
      if (this.$route.query.order_no) {
        this.orderNo = this.$route.query.order_no;
      } else {
        this.orderNo = "";
      }
      // if (localStorage.getItem("userinfo")) {
      //   this.userId = localStorage.getItem("userinfo").id;
      // } else {
      //   this.userId = "";
      // }
      this.request("getDetail", {
        order_no: this.orderNo
      })
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      payment() {
        let that = this
        let order_param = {}
        Dialog.confirm({
            title: '提示',
            message: '是否使用微信支付?',
          })
          .then(() => {
            order_param.amount = this.orderDetail.settlement_amount
            order_param.order_no = this.orderNo
             order_param.pay_type = 'wechatpay'
            // order_param.pay_type = 'wechatpay'
            that.request('WxunifiedOrder', order_param)
          })
          .catch(() => {
            return false;
          });
      },
      toIndex(){
        this.$router.push({
          path:"/"
        })
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          case 'getDetail':
            httper.get('/annual-review/second-order', requestData, res => {
              if (res.code == 0) {
                console.log("res", res)
                this.orderDetail = res.data
              } else {
                this.$toast({
                  message: res.message || '系统异常'
                })
              }
            },true)
            break
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/unified-second-order', requestData, res => {
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
            case 'orderCancel':
              httper.post('/order/cancel', requestData, res => {
                console.log("取消", res)
                if (res.code === 0) {
                  // that.pay(res.data.payment_packet, res.data.order_no)
                } else {
                  this.$toast({
                    message: res.message || '系统异常',
                  })
                }
              }, true)
              break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.$router.push({
                path: '/orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style>
  body {
    background-color: #FFFFFF;
  }

  .secondPaymentDetail_title {
    width: 100%;
    padding: 5px 20px;
    box-sizing: border-box;
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;
  }

  .secondPaymentDetail_tip {
    color: #FE0304;
    font-size: 12px;
  }

  .secondPaymentDetail_mesg {}

  .secondPaymentDetail_tackimg {
    width: calc(100% - 40px);
    margin: 20px;
    height: 207px;
  }

  .secondPaymentDetail_imgdefault {
    width: 100%;
    height: 100%;
  }

  .secondPaymentDetail_pickaddressbox {
    width: calc(100% - 40px);
    margin: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }

  .secondPaymentDetail_addresstitle {
    font-size: 14px;
    width: 20%;
  }

  .secondPaymentDetail_addresstitle1 {
    font-size: 14px;
    width: 60%;
  }

  .secondPaymentDetail_addressdetail {
    font-size: 14px;
    color: #FD8C00;
  }

  .secondPaymentDetail_address {
    font-size: 14px;
    color: #BCBCBC;
    margin-right: 10px;
  }

  .secondPaymentDetail_more {
    width: 10px;
    height: 15px;
  }

  .secondPaymentDetail_check {
    width: calc(100% - 40px);
    margin: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .secondPaymentDetail_checktitle {
    font-size: 14px;
  }

  .secondPaymentDetail_checkbox {
    display: flex;
    align-items: center;
  }

  .secondPaymentDetail_checktrue {
    display: flex;
    align-items: center;
    margin-left: 15px;
  }

  .secondPaymentDetail_checkicon {
    width: 14px;
    height: 14px;
    margin-right: 10px;
  }

  .secondPaymentDetail_checktext {
    font-size: 14px;
  }

  .secondPaymentDetail_describe {
    width: calc(100% - 40px);
    margin: 0 20px;
    height: 150px;
    font-size: 14px;
  }

  textarea {
    border: none;
    outline: none;
  }

  textarea::-webkit-input-placeholder {
    font-size: 14px;
  }

  .secondPaymentDetail_autographtitle {
    width: calc(100% - 40px);
    margin: 20px;
    font-size: 14px;
  }

  .secondPaymen-confirmtoptext {
    width: 100%;
    background-color: #F2F2F2;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    box-sizing: border-box;
    margin-bottom: 20px;
    font-size: 12px;
    color: #666666;
    font-weight: 400;
  }

  .secondPaymen-confirm-pro {
    width: 50%;
    text-align: left;
    padding-left: 20px;
    /* box-sizing: border-box; */
  }

  .secondPaymen-confirm-mprice {
    width: 30%;
    text-align: left;
  }

  .secondPaymen-confirm-price {
    width: 20%;
    text-align: left;
  }

  .secondPaymen-title {
    font-size: 19px;
    color: #333333;
  }

  .secondPaymen-cancel {
    width: 16px;
    height: 16px;
    margin-left: 32%;
  }

  .secondPaymen-confirmbox1 {
    width:calc(100% - 40px);
    display: flex;
    align-items: center;
    margin: 20px;
  }

  .secondPaymen-confirm-proname {
    width: 50%;
    text-align: start;
    font-size: 14px;
    color: #666666;
    font-weight: 400;
  }

  .secondPaymen-confirm-mprice1 {
    width: 25%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #FD8C00;
    font-weight: 400;

  }

  .secondPaymen-confirm-pricetip {
    margin-right: 5px;
  }

  .secondPaymen-confirm-pricevlue {}

  .secondPaymen-confirm-price1 {
    width: 25%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #FD8C00;
    font-weight: 400;
  }

  .secondPaymen-confirm-text {
    width: 100%;
    height: 181px;
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #AAAAAA;
    border-radius: 4px;
    font-weight: 400;
    text-align: start;
  }

  .secondPaymentDetail_box {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }

  .secondPayment_zhifu {
    width: calc(100% - 40px);
    margin: 20px;
    height: 46px;
   background: #FD8C00;
   box-shadow: 0 4px 5px 2px rgba(253, 140, 0, 0.3);
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/SecondPayment/SecondPayment.vue